/**
 * <strong>Properties:</strong><br>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ArrowModeMixin|arrowMode}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ButtonGroupMixin|buttonGroup}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/CheckedMixin|checked}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DescriptionMixin|description}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DisabledMixin|disabled}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/HasDynamicMenuMixin|hasDynamicMenu}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/IconMixin|icon}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/IconAlignmentMixin|iconAlignment}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/MenuMixin|menu}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TagMixin|tag}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TextMixin|text}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ValidationMixin|validationState, errorText, warningText}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/SizeMixin|width, height}</li>
 * <br>
 * <br>
 * <strong>Events:</strong>
 * <br>
 * <br>
 * <li>dropdownclick</li>
 * <br>
 * <br>
 * <strong>Example:</strong>
 * <br>
 * <br>
 * For a working example, see the {@link http://inside-files/dev/eps/WIT/WebWidgets/Gallery/Gallery/|gallery}
 * <br>
 * <br>
 * @module mw-form/ToggleSplitButton
 *
 * @copyright Copyright 2015-2018 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",

    "dijit/_WidgetBase",
    "dijit/_Contained",
    "dijit/_FocusMixin",
    "dijit/_TemplatedMixin",
    "mw-form/mixins/property/TagMixin",
    "mw-form/mixins/property/MenuMixin",
    "mw-form/mixins/property/HasDynamicMenuMixin",
    "mw-form/mixins/property/DisabledMixin",
    "mw-form/mixins/property/CheckedMixin",
    "mw-form/mixins/property/ButtonGroupMixin",
    "mw-form/mixins/property/DescriptionMixin",
    "mw-form/mixins/property/IconAlignmentMixin",
    "mw-form/mixins/property/IconMixin",
    "mw-form/mixins/property/ArrowModeMixin",
    "mw-form/mixins/property/SizeMixin",
    "mw-form/mixins/property/TabIndexNodesMixin",
    "mw-form/mixins/property/TextMixin",
    "mw-form/mixins/property/VisualFamilyMixin",
    "mw-form/mixins/property/ValidationMixin",
    "mw-form/mixins/event/ChangeEventMixin",

    "mw-form/mixins/AccessibilityClickMixin",
    "mw-form/mixins/SplitTypeButtonsAriaLabelledByMixin",
    "mw-form/mixins/PreventSelectionMixin",

    "mw-form/mixins/property/DropDownButtonIconAlignmentMixin",
    "mw-form/mixins/property/DropDownButtonArrowModeMixin",
    "mw-form/mixins/property/DropDownButtonTextMixin",
    "mw-form/mixins/property/DropDownButtonSizeMixin",
    "mw-form/mixins/property/DropDownNeverDisabledMixin",
    "mw-form/mixins/SplitButtonToggleSplitButtonMenuMixin",
    "mw-form/mixins/SplitButtonToggleSplitButtonFocusMixin",
    "mw-form/mixins/SplitButtonToggleSplitButtonDescriptionMixin",

    "mw-form/mixins/mixinDependencyValidator",

    "dojo/text!mw-form/templates/DropDownButton.html"
], function (declare, _WidgetBase, _Contained, _FocusMixin, _TemplatedMixin, TagMixin, MenuMixin, HasDynamicMenuMixin,
             DisabledMixin, CheckedMixin, ButtonGroupMixin, DescriptionMixin, IconAlignmentMixin, IconMixin, ArrowModeMixin,
             SizeMixin, TabIndexNodesMixin, TextMixin, VisualFamilyMixin, ValidationMixin, ChangeEventMixin, AccessibilityClickMixin,
             SplitTypeButtonsAriaLabelledByMixin, PreventSelectionMixin, DropDownButtonIconAlignmentMixin,
             DropDownButtonArrowModeMixin, DropDownButtonTextMixin, DropDownButtonSizeMixin, DropDownNeverDisabledMixin,
             SplitButtonToggleSplitButtonMenuMixin, SplitButtonToggleSplitButtonFocusMixin, SplitButtonToggleSplitButtonDescriptionMixin,
             mixinDependencyValidator, template) {

    return declare(mixinDependencyValidator.validate([_WidgetBase, _Contained, _FocusMixin, _TemplatedMixin, TagMixin,
        MenuMixin, HasDynamicMenuMixin, DisabledMixin, CheckedMixin, ButtonGroupMixin, DescriptionMixin, IconAlignmentMixin,
        IconMixin, ArrowModeMixin, SizeMixin, TabIndexNodesMixin, TextMixin, VisualFamilyMixin, ValidationMixin,
        ChangeEventMixin, AccessibilityClickMixin, SplitTypeButtonsAriaLabelledByMixin, PreventSelectionMixin,
        DropDownButtonIconAlignmentMixin, DropDownButtonArrowModeMixin, DropDownButtonTextMixin, DropDownButtonSizeMixin,
        DropDownNeverDisabledMixin, SplitButtonToggleSplitButtonMenuMixin, SplitButtonToggleSplitButtonFocusMixin,
        SplitButtonToggleSplitButtonDescriptionMixin]), {

        baseClass: "mwWidget mwToggleSplitButton",
        templateString: template,

        cssStateNodes: {
            "buttonNode": "mwButtonNode",
            "dropDownNode": "mwDropDownNode"
        },

        postCreate: function () {
            this.set("checkableNode", this.buttonNode);

            // ButtonNode should have aria-pressed attribute
            this.buttonNode.setAttribute("aria-pressed", this.get("checked"));

            this.inherited(arguments);
        }
    });
});